import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Root = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),

  a: {
    ...theme.typography['Lato Link 2'],
    color: theme.palette.primary.main,
  },
}))

Root.defaultProps = {
  variant: 'Lato Body 2',
}
